import * as iconsObject from './icons';

const icons = Object.values(iconsObject);

export { icons };
